import ThirdPartyLinkingDialog from "./ThirdPartyLinkingDialog";
import DiscoverWonderPageDialog from "./DiscoverWonderPageDialog";
import CookieComplianceDialog from "./CookieComplianceDialog";

export const handleDisableBackdropClick = (event, reason) => {
  if (reason === "backdropClick") return false;
};

export default function Dialogs() {
  return (
    <>
      <ThirdPartyLinkingDialog />
      <DiscoverWonderPageDialog />
      <CookieComplianceDialog />
    </>
  );
}
